import React from 'react'
import '../styles/About.css'

export default function About() {
    return (
        <>
            <div className="about pd">
                <div className="container">
                    <h3 className="title">About us</h3>
                    <div className="row">
                        <div className="col-md-8">
                            <div className="row">
                                <div className="col-md-4">
                                    <span id="before"></span>
                                    <div className="aboutCard">
                                        <div className="icon"><img src="./images/puzzle.png" alt="test"/></div>
                                        <h5>Creative</h5>
                                        <p>We are creative team can give you basic and advanced knowledge</p>
                                    </div>
                                    <span id="after"></span>
                                </div>
                                <div className="col-md-4">
                                    <span id="before"></span>
                                    <div className="aboutCard">
                                        <div className="icon"><img src="./images/favorites.png" alt="tetst"/></div>
                                        <h5>Professional</h5>
                                        <p>We have professional instructors serve your needs of learning </p>
                                    </div>
                                    <span id="after"></span>
                                </div>
                                <div className="col-md-4">
                                    <span id="before"></span>
                                    <div className="aboutCard">
                                        <div className="icon"><img src="./images/diversify.png" alt="test"/></div>
                                        <h5>Variety</h5>
                                        <p>Alot of new and various courses</p>
                                    </div>
                                    <span id="after"></span>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="image">
                                <img src="./images/el1.png" alt="test"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
